import { RouteMap } from '@constants/routes';

interface TreePathItem {
  id: string;
  entityId: number;
  label: string;
  url?: string;
}

const typeUrl = {
  substation: 'umspannwerk',
  measurmentPoint: 'messpunkt',
  measurmentDevice: 'messgeraet',
};

export const findTreePath = (tree: TreeListItemTsoPqProps[], tragetdId: string): TreePathItem[] | undefined => {
  return tree.reduce<TreePathItem[] | undefined>((path, node) => {
    if (path) return path;

    if (node.id === tragetdId) {
      return [
        {
          id: node.id,
          entityId: node.entityId,
          label: node.label,
        },
      ];
    }

    if (node.options) {
      const subPath = findTreePath(node.options, tragetdId);
      if (subPath) {
        return [
          {
            id: node.id,
            entityId: node.entityId,
            label: node.label,
            url: `${RouteMap.ADMINISTRATION_ROUTE}/${typeUrl[node.type as keyof typeof typeUrl]}/${node.entityId}`,
          },
          ...subPath,
        ];
      }
    }

    return undefined;
  }, undefined);
};
